import { giphyCharcoal, giphyDarkestGrey } from '@giphy/colors'
import { useContext } from 'react'
import { IconComponent, SegmentedControl } from 'ui'
import { UGEContext } from '../../../context'
import { Subheading } from '../../style'

const OPTIONS = ['Normal', 'Reverse']

type Props = {
    className?: string
}

const UGEDefaultEditorLoopType = ({ className }: Props) => {
    const { duration, reversed, sourceInfo, setReversed } = useContext(UGEContext)

    function onChange(index: number) {
        setReversed(index > 0 ? true : false)
    }

    return (
        <div className={className}>
            <Subheading>
                <IconComponent color={giphyCharcoal} height={18} icon="loop" width={18} />
                Loop Type
            </Subheading>
            <SegmentedControl
                backgroundColor={giphyDarkestGrey}
                disabled={!duration || !sourceInfo?.duration}
                index={reversed ? 1 : 0}
                options={OPTIONS}
                size="medium"
                onChange={onChange}
            />
        </div>
    )
}

export default UGEDefaultEditorLoopType
